import type { ChangelogEntry } from "../types";

/** VIB-2846 + VIB-2847. Bildet vises igjen fra verktøylinja, og kan få størrelse. */
export const BILDESTORRELSE_2026_10: ChangelogEntry = {
  id: "2026-10-08-bildestorrelse",
  date: "2026-10-08",
  title: "Bilder i dokumenter kan få størrelse",
  summary:
    "Et bilde du setter inn fra verktøylinja vises igjen, og du kan velge om det skal være lite, middels eller i full bredde.",
  sections: [
    {
      heading: "Dokumentarkiv",
      items: [
        {
          title: "Velg størrelse på et bilde",
          kind: "nytt",
          body: "Klikk på et bilde i teksten, så kommer tre valg fram i hjørnet av det: liten, medium og full bredde. Valget lagres med dokumentet, så alle som leser det ser bildet i samme størrelse.",
        },
        {
          title: "Bilde satt inn fra verktøylinja ble usynlig",
          kind: "rettet",
          body: "Satte du inn et bilde med bilde-knappen, ble det liggende som et tomt felt i teksten. Det virket hvis du dro bildet inn eller limte det inn, men ikke fra knappen. Nå vises bildet uansett hvordan du setter det inn.",
        },
      ],
    },
  ],
};
